import { notification } from 'antd'
import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'
import { CarrierFilters } from '@types'

import { CarriersApi } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los carriers',
  })
}

const useCarriers = (filters?: CarrierFilters) => {
  const { data: allCarriers, isLoading: isLoadingAllCarriers } = useQuery(
    [QUERY_KEYS.ALL_CARRIERS, { filters }],
    () => CarriersApi.getCarriersWithFilters({ filters: { ...filters, limit: 400 } }),
    {
      staleTime: 60000,
      onError,
    },
  )

  // Dejo solo esta
  const allCarriersOptions = allCarriers?.carriers
    .map(carrier => ({
      label: carrier.businessName,
      value: carrier.id,
    }))
    .sort((a, b) => (a.label.toUpperCase() < b.label.toUpperCase() ? -1 : 1))

  return {
    carriers: allCarriers?.carriers,
    allCarriersOptions,
    isLoadingAllCarriers,
  }
}

export { useCarriers }
